/* eslint-disable import/prefer-default-export */

import $http from '@vue-util/http';
import { SizeChartError } from '../errors/SizeChartError';
import { sizeChartMapper } from '../mappers';

function buildUrl({ hostlink = '', productId, chartId }) {
  return `${hostlink}/xapi/digital/v1/product/${productId}/sizechart/${chartId}`;
}

const fetch = (hostlink) => async function fetchChart({ productId, chartId }) {
  const url = buildUrl({ hostlink, productId, chartId });

  try {
    const response = await $http.get(url);
    const mappedResponse = sizeChartMapper(response.data);
    return mappedResponse;
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
    throw new SizeChartError(e.message);
  }
};

export default fetch;
